export default function BellNotificationFilled({
  size = 40,
  className = '',
}: {
  size?: number;
  className?: string;
}) {
  return (
    <>
      <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.31689 3.39967L5.12523 2.20801C3.12523 3.73301 1.80856 6.08301 1.69189 8.74967H3.35856C3.48356 6.54134 4.61689 4.60801 6.31689 3.39967ZM16.6419 8.74967H18.3086C18.1836 6.08301 16.8669 3.73301 14.8752 2.20801L13.6919 3.39967C15.3752 4.60801 16.5169 6.54134 16.6419 8.74967ZM15.0002 9.16634C15.0002 6.60801 13.6336 4.46634 11.2502 3.89967V3.33301C11.2502 2.64134 10.6919 2.08301 10.0002 2.08301C9.30856 2.08301 8.75023 2.64134 8.75023 3.33301V3.89967C6.35856 4.46634 5.00023 6.59967 5.00023 9.16634V13.333L3.33356 14.9997V15.833H16.6669V14.9997L15.0002 13.333V9.16634ZM10.0002 18.333C10.1169 18.333 10.2252 18.3247 10.3336 18.2997C10.8752 18.183 11.3169 17.8163 11.5336 17.3163C11.6169 17.1163 11.6586 16.8997 11.6586 16.6663H8.32523C8.33356 17.583 9.07523 18.333 10.0002 18.333Z" />
      </svg>
    </>
  );
}
